<template functional>
    <router-link
            :to="Number.parseInt(props.match.numberOfOdds, 10) > 0 ? $options.sanitizeUrl(props.match) : '#'"
            class="bto-sb-event-odds-cell bto-sb-event-more-odd" :class="{'bto-sb-event-more-cash' : props.cashOutVisibility && props.match.data.cs}">
            <span v-if="!props.showMarketsInMatch && props.match.numberOfOdds>0">
              + {{props.match.numberOfOdds}}
            </span>
            <span v-if="props.showMarketsInMatch && props.match.numberOfMarkets>0">
              + {{props.match.numberOfMarkets}}
            </span>
            <i class="bto-app-cash" v-if="props.cashOutVisibility && props.match.data.cs"></i>
    </router-link>
</template>

<script>
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'MoreOdds',
    sanitizeUrl(match) {  
      const sportName = urlFriendlyParam(match.sportName);
      const categoryName = urlFriendlyParam(match.tournamentName);
      const eventName = urlFriendlyParam(`${match.homeTeam} vs ${match.guestTeam}`);
      return { name: 'seoGameLive', params: { sportName, categoryName, eventName, matchId: match.betRadarId } };
    },
    props: {
      match: {
        type: Object,
        required: true,
        default: () => {
        }
      },
      cashOutVisibility:{
        type: Boolean,
        required: true,
        default: () => {
        }
      },
      showMarketsInMatch: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
